import { render } from "./WalletExchangePositionsList.vue?vue&type=template&id=515babae&scoped=true"
import script from "./WalletExchangePositionsList.vue?vue&type=script&lang=js"
export * from "./WalletExchangePositionsList.vue?vue&type=script&lang=js"

import "./WalletExchangePositionsList.vue?vue&type=style&index=0&id=515babae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-515babae"]])

export default __exports__